import { IAccountingField } from '@Shared/accounting_field';

export const SET_ACCOUNTING_FIELDS = 'SET_ACCOUNTING_FIELDS';

export class SetAccountingFields {
  readonly type = SET_ACCOUNTING_FIELDS;
  readonly payload: IAccountingField[];

  constructor(accountingFields: IAccountingField[]) {
    this.payload = accountingFields;
  }
}

export type AccountingFieldsAction = SetAccountingFields;
